
import { defineComponent, PropType } from 'vue'

interface SectionData {
  filledCount: number
  totalCount: number
  modified: boolean
}

export default defineComponent({
  props: {
    data: { type: Object as PropType<SectionData>, required: true }
  },
  computed: {
    labelText(): string {
      // console.log({ filledCount: this.data.filledCount, totalCount: this.data.totalCount, modified: this.data.modified })
      if (this.data.modified) return 'MODIFIÉ' // TODO: i18n
      return `${this.data.filledCount}/${this.data.totalCount}`
    },
    colorClass(): string {
      if (this.data.modified) return 'bg-primary-blue'
      if (this.data.filledCount == this.data.totalCount) return 'bg-green'
      return 'bg-red'
    }
  }
})
